import { FC } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Loading from 'src/layout/Loading';
import { getLogOrders, getOrder } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

import { useTitle } from '../hooks/useTitle';

import OrderDetail from 'src/components/templates/OrderDetail/OrderDetail';

const getLogsForOrder = async (args: [string, string]) => {
  const [, orderId] = args;
  return getLogOrders([['body.orderId', '==', orderId]], {
    sortKey: '_timeCreate',
    orderBy: 'desc',
  });
};

const OrderDetailPage: FC = () => {
  useTitle('GU | 주문 상세');
  const { orderId } = useParams();
  const { data, isLoading } = useSWR(orderId ? orderId : null, getOrder, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });
  const { data: logs } = useSWR(orderId ? ['logOrder', orderId] : null, getLogsForOrder, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  if (!orderId) {
    return <Navigate to='/' replace />;
  }

  if (isLoading) {
    return <Loading />;
  }

  return <OrderDetail order={data} logs={logs} />;
};

export default OrderDetailPage;
